<template>
  <div>
    <ListLayout
      :title="`${companyModule.companyPlural}`"
      :tableData="companyList"
      :tableHeader="tableHeaders"
      :context="context"
      :total="totalItems"
      @getList="getCompanyList"
      ref="listTable"
    >
      <template #listAction>
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <div v-on="{ ...tooltip }">
              <PrimaryButton
                id="companiesAdd"
                @click="$router.push({ name: 'add-company' })"
                icon="mdi-plus"
                :name="`Add ${companyModule.company}`"
                iconSize="x-large"
              >
              </PrimaryButton>
            </div>
          </template>
          <span>{{ buttonTooltip }}</span>
        </v-tooltip>
      </template>
      <template #rightFilterSlot>
        <div class="w-100 d-flex align-center justify-end">
          <RefreshListButton
            id="companyRefreshList"
            :isIcon="false"
            @click="$refs.listTable.searchTriggered()"
          />
        </div>
      </template>
      <template #dialogs>
        <SubscriptionRenew
          v-model="showSubscriptionForm"
          :companyObject="selectedCompany"
          @reloadWindow="$refs.listTable.searchTriggered()"
        />
      </template>
    </ListLayout>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import CompanyButton from "@/components/Button/CompanyButton.vue";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import CompanyStatus from "@/components/AgIcon/CompanyStatus.vue";
import CompanyGeoFence from "@/components/AgIcon/CompanyGeoFence.vue";
import CompanyHasItems from "@/components/AgIcon/CompanyHasItems.vue";
import { getUserDetailsLocalStorage } from "@/utils/functions";
import SubscriptionRenew from "@/components/ModuleBasedComponents/Company/SubscriptionRenew.vue";
import SubscriptionWarning from "@/components/AgIcon/SubscriptionWarning.vue";
import { companyModule } from "@/utils/moduleMapping";
import RefreshListButton from "@/components/BaseComponents/RefreshListButton.vue";

export default {
  components: {
    CompanyButton,
    ListLayout,
    CompanyStatus,
    CompanyGeoFence,
    CompanyHasItems,
    SubscriptionRenew,
    SubscriptionWarning,
    RefreshListButton,
  },
  data() {
    return {
      companyModule,
      buttonTooltip: "Add Company",
      sorting: {},
      itemsPerPage: 10,
      pageNo: 1,
      totalItems: 0,
      filters: {},
      companyList: [],
      systemAdminHeaders: [
        {
          headerName: "#",
          field: "is_subscription_expired",
          sortable: false,
          width: "50",
          pinned: "left",
          cellRenderer: "SubscriptionWarning",
        },
        {
          headerName: "Company Name",
          field: "name",
          sortable: true,
          pinned: "left",
        },
        {
          headerName: "Account Manager",
          field: "account_manager",
          sortable: true,
          pinned: "left",
        },
        {
          headerName: "Contact Number",
          field: "contact_number",
          sortable: true,
        },
        {
          headerName: "Address",
          field: "address",
          sortable: true,
          tooltipField: "address",
        },
        {
          headerName: "Status",
          field: "is_active",
          sortable: true,
          cellRenderer: "CompanyStatus",
        },
        {
          headerName: "Geofence Required",
          field: "geofence_required",
          sortable: true,
          cellRenderer: "CompanyGeoFence",
        },
        {
          headerName: "Has Items",
          field: "has_items",
          sortable: true,
          cellRenderer: "CompanyHasItems",
        },
      ],
      headerSelected: [
        {
          headerName: "#",
          field: "is_subscription_expired",
          sortable: false,
          pinned: "left",
          width: "50",
          cellRenderer: "SubscriptionWarning",
        },
        {
          headerName: "Company Name",
          field: "name",
          sortable: true,
          pinned: "left",
        },
        {
          headerName: "Contact Number",
          field: "contact_number",
          sortable: true,
        },
        {
          headerName: "Address",
          field: "address",
          sortable: true,
          tooltipField: "address",
        },
        {
          headerName: "Status",
          field: "is_active",
          sortable: true,
          cellRenderer: "CompanyStatus",
        },
        {
          headerName: "Geofence Required",
          field: "geofence_required",
          sortable: true,
          cellRenderer: "CompanyGeoFence",
        },
        {
          headerName: "Has Items",
          field: "has_items",
          sortable: true,
          cellRenderer: "CompanyHasItems",
        },
      ],

      isEditing: false,
      showCompanyForm: false,
      selectedCompanyID: null,

      selectedCompany: {},
      showSubscriptionForm: false,
    };
  },
  computed: {
    tableHeaders() {
      let userObj = getUserDetailsLocalStorage();
      return [
        ...(userObj.role == "system_admin"
          ? this.systemAdminHeaders
          : this.headerSelected),
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 180,
          sortable: false,
          width: 180,
          cellRenderer: "CompanyButton",
        },
      ];
    },
    context() {
      return { parentComponent: this };
    },
  },
  methods: {
    openSubscriptionRenewForm(company) {
      this.selectedCompany = company;
      this.showSubscriptionForm = true;
    },
    getCompanyList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        ...this.filters,
      };

      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }

      this.$api.company
        .getCompanyList(params)
        .then((res) => {
          this.companyList = res.data;
          this.totalItems = res.count;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>
